"use client"

import { useState } from "react"
import { useRouter } from "next/navigation"
import { apiService } from "@/lib/api"
import { useAuth } from "@/contexts/auth-context"

export const useAuthCheck = () => {
  const [showAuthPopup, setShowAuthPopup] = useState(false)
  const [authAction, setAuthAction] = useState("")
  const router = useRouter()
  const { token, isAuthenticated, user } = useAuth()

  const openAuthPopup = (action: string) => {
    setAuthAction(action)
    setShowAuthPopup(true)
  }

  const checkAuth = async (action: string, callback?: () => void) => {
    console.log('Auth check - Token:', token ? 'Present' : 'Missing')
    console.log('Auth check - isAuthenticated:', isAuthenticated)
    console.log('Auth check - user:', user)

    if (!isAuthenticated || !token || !user) {
      openAuthPopup(action)
      return false
    }

    // Token is already validated by auth context
    console.log('Token is valid')
    if (callback) {
      callback()
    }

    return true
  }

  const redirectToLogin = () => {
    router.push('/login')
  }

  const closeAuthPopup = () => {
    setShowAuthPopup(false)
    setAuthAction("")
  }

  return {
    checkAuth,
    openAuthPopup,
    redirectToLogin,
    showAuthPopup,
    authAction,
    closeAuthPopup
  }
}
